import { familyTypes } from "../../constants/acs/prePurcaseAayuData";

function getRecommendedPlanData(recommendedPlanConsultation, aayuCardPlans : any, recommendedPlan = {}, otherPlans: any[] = []) {
    var plans = aayuCardPlans;
    plans.filter(item => item.canPurchase === true).map((plan) => {
        if (plan.consultations == recommendedPlanConsultation) {
            // recommendedPlan = plans.splice(index, 1)[0];
            // otherPlans = plans;
            recommendedPlan = plan;
        } else otherPlans.push(plan);
    }); return {
        recommended : recommendedPlan,
        otherPlans : otherPlans,
    }
}

export function getAayuRecommendationPlan(familytype, familyProblem, aayuCardPlans) {
    const problemLength = familyProblem.length;
    switch(familyTypes[familytype]['label']) {
        case 'Joint Family':
            if (problemLength == 1)
                return getRecommendedPlanData(12, aayuCardPlans);
            else return getRecommendedPlanData(25, aayuCardPlans);
        // case 'Couple':
        //     if (problemLength == 1)
        //     return getRecommendedPlanData(12, aayuCardPlans);
        //     else return getRecommendedPlanData(25, aayuCardPlans);
        // case 'Couple with kids':
        //     if (problemLength == 1)
        //     return getRecommendedPlanData(12, aayuCardPlans);
        //     else return getRecommendedPlanData(25, aayuCardPlans)
        // case 'Myself':
        //     if (problemLength == 1)
        //     return getRecommendedPlanData(12, aayuCardPlans)
        //     else return getRecommendedPlanData(25, aayuCardPlans);
        default:
            if (problemLength <= 2)
                return getRecommendedPlanData(12, aayuCardPlans);
            else return getRecommendedPlanData(25, aayuCardPlans);
    }
}